/* eslint-disable */
module.exports = require('./lib/parcelData/asRaw.js')["default"];